module.exports = __webpack_public_path__ + "rw-widgets.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/react-widgets/fonts/rw-widgets.eot?v=4.1.0
 ** module id = 568
 ** module chunks = 0
 **/